/**
 * Dataset size limits shared by the upload flow and the Train gate.
 *
 * Mirrors ``optuneutils/constants/dataset_size.py`` (limit value, size
 * formatting and the upload-rejection wording) — the backend enforces the same
 * limit server-side, so keep both files in sync when changing any of these.
 */

const KIB = 1024;
const MIB = KIB * 1024;
const GIB = MIB * 1024;

/** Maximum size of a single dataset/benchmark file (5 GiB, inclusive). */
export const MAX_DATASET_FILE_SIZE_BYTES = 5 * GIB;

/** Human label used in user-facing limit messages. */
export const DATASET_SIZE_LIMIT_LABEL = '5 GB';

/**
 * Format a byte count (1024-based) as ``<n> B`` / ``<n.n> KB`` / ``<n.n> MB``
 * / ``<n.nn> GB``. Non-finite or negative input renders as ``0 B``.
 */
export function formatDataSize(bytes) {
    if (!Number.isFinite(bytes) || bytes < 0) return '0 B';
    if (bytes < KIB) return `${Math.round(bytes)} B`;
    if (bytes < MIB) return `${(bytes / KIB).toFixed(1)} KB`;
    if (bytes < GIB) return `${(bytes / MIB).toFixed(1)} MB`;
    return `${(bytes / GIB).toFixed(2)} GB`;
}

/** Upload-rejection message; wording matches the backend's own rejection so both paths read the same. */
export function uploadFileTooLargeMessage(fileName, sizeBytes) {
    return `The file '${fileName}' is ${formatDataSize(sizeBytes)}, which exceeds the maximum dataset file size of ${DATASET_SIZE_LIMIT_LABEL}. Reduce the file size and upload it again.`;
}
